<template>
<body class="white-bg">
    <div class="research">
       <div id="complete" class="ibox page-full">
          <div class="r-header">
             {{headerText}}
          </div>
          <div class="r-box page-middle no-borders">
             <div class="text-center mb-4 r-notice" style="padding: 10px 0px;">
                <div style="font-size: 20px;">
                   <span v-html="completeText"></span>
                </div>
             </div>
          </div>
       </div>
    </div>
 </body>
</template>

<script>

export default {
  name: 'answer-complete',
  props: {
    mode: String,
  },
  data() {
    return {
       headerText: null,
        completeText: null,
    }
  },
  mounted() {
      window.scrollTo(0, 0)

      if (this.mode == 'event') {
         this.headerText = "제출 완료"
         this.completeText = "제출이 완료 되었습니다.<br/><br/>감사합니다."
      }
      
  },
  methods: {
      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
